import { useFormStepper } from '@1trading/react/components/ui/form-stepper';

import { noop } from '@/utils';

export const useAutoNextStep = (isDisabled: boolean) => {
  const { nextStepDeferred } = useFormStepper();

  return isDisabled ? noop : nextStepDeferred;
};
